import { render, staticRenderFns } from "./BoxWithIcon.vue?vue&type=template&id=1acf727a&scoped=true"
import script from "./BoxWithIcon.vue?vue&type=script&lang=js"
export * from "./BoxWithIcon.vue?vue&type=script&lang=js"
import style0 from "./BoxWithIcon.vue?vue&type=style&index=0&id=1acf727a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf727a",
  null
  
)

export default component.exports